import React from 'react';
import { QuoteIcon, UserIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author?: string;
  location?: string;
  age?: string;
  imageUrl?: string;
}
export const TestimonialCard = ({
  quote,
  author,
  age,
  location,
  imageUrl
}: TestimonialCardProps) => {
  return <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-red-400" data-id="element-282">
      <div className="flex items-center mb-4" data-id="element-283">
        <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center mr-3 overflow-hidden" data-id="element-284">
          {imageUrl ? <img src={imageUrl} alt={author || 'Testimonial author'} className="w-full h-full object-cover" data-id="element-285" /> : <UserIcon className="text-gray-400" size={24} data-id="element-286" />}
        </div>
        {(author || age || location) && <div data-id="element-287">
            {author && <p className="font-semibold text-gray-800" data-id="element-288">{author}</p>}
            {(age || location) && <p className="text-sm text-gray-600" data-id="element-289">
                {[age, location].filter(Boolean).join(', ')}
              </p>}
          </div>}
      </div>
      <div className="flex mb-2" data-id="element-290">
        <QuoteIcon className="text-red-400 mr-2 flex-shrink-0" size={20} data-id="element-291" />
      </div>
      <p className="italic mb-3" data-id="element-292">{quote}</p>
    </div>;
};